// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p.desc-short {
  font-weight: bold;
  font-size: 24px;
  margin: 0px;
}

ion-item.total-row {
  width: 100%;
  padding-left: 0px;
}
ion-item.total-row ion-label {
  font-weight: bold;
  font-size: 24px !important;
}

ion-grid {
  padding-inline: 0px;
}
ion-grid ion-col {
  display: flex;
  align-items: center;
}
ion-grid ion-col.ion-col-trash {
  display: grid;
  justify-content: center;
  align-items: center;
}
ion-grid ion-col.ion-col-numpad {
  justify-content: space-evenly;
  display: flex;
  align-items: center;
}
ion-grid ion-col.ion-col-numpad h2 {
  font-size: 24px;
  font-weight: bold;
}
ion-grid ion-col.ion-col-numpad .btn-qty {
  max-width: 45px;
  height: 45px;
  --border-radius: 10px;
}

div.container {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/app/components/form/quotation/product-accessory/quotation-product-accessory/quotation-product-accessory.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EAEA,eAAA;EAEA,WAAA;AADJ;;AAIA;EAEI,WAAA;EAEA,iBAAA;AAHJ;AAKI;EACI,iBAAA;EACA,0BAAA;AAHR;;AAOA;EACI,mBAAA;AAJJ;AASI;EAEI,aAAA;EAEA,mBAAA;AATR;AAaI;EAMQ,aAAA;EAEA,uBAAA;EAEA,mBAAA;AAlBZ;AAsBI;EAII,6BAAA;EAEI,aAAA;EAIA,mBAAA;AA3BZ;AAkCQ;EAEI,eAAA;EACA,iBAAA;AAjCZ;AAoCQ;EAEI,eAAA;EACA,YAAA;EAEA,qBAAA;AApCZ;;AA2CA;EACI,gBAAA;AAxCJ","sourcesContent":["p.desc-short{\n    font-weight: bold;\n\n    font-size: 24px;\n\n    margin: 0px;\n}\n\nion-item.total-row {\n\n    width: 100%;\n\n    padding-left: 0px;\n\n    ion-label{\n        font-weight: bold;\n        font-size: 24px !important;\n    }\n} \n\nion-grid{\n    padding-inline: 0px;\n    ion-row{\n        // padding: 0px 20px;\n    }\n\n    ion-col{\n\n        display: flex;\n\n        align-items: center;\n\n    }\n\n    ion-col.ion-col-trash{\n\n        // display: flex;\n\n        // justify-content: space-evenly;\n        \n            display: grid;\n    \n            justify-content: center;\n\n            align-items: center;\n\n    }\n\n    ion-col.ion-col-numpad{\n\n        // display: flex;\n\n        justify-content: space-evenly;\n        \n            display: flex;\n    \n            // justify-content: end;\n\n            align-items: center;\n        \n            // .container-qty{\n            \n        // }\n\n\n        h2{\n            // margin: 10px auto;\n            font-size: 24px;\n            font-weight: bold;\n        }\n\n        .btn-qty{\n\n            max-width:45px;\n            height:45px;\n\n            --border-radius: 10px;\n        }\n\n\n    }   \n}\n\ndiv.container{\n    text-align:left\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
